







































import { Component, Vue } from 'vue-property-decorator'
import verifyCodes from './components/MobileEmailDetails.vue'
import { setLocalStorage, getLocalStorage } from '../../store/src/utils/index'
@Component({
	components: {
		verifyCodes
	}
})
export default class MobileEmail extends Vue {
	private mobileFlag: string = 'mobile'
	private mobileTitle: string = '手机号：'
	private mobileInputDisabled: boolean = true
	private stateMobile: boolean = true
	private mobileName: string = ''
	private emailFlag: string = 'email'
	private emailTitle: any = '邮   箱：'
	private emailInputDisabled: boolean = true
	private stateEmail: boolean = true
	private emailName: string = ''
	private created () {
		this.mobileName = getLocalStorage('loginerTel', '')
		if (!this.mobileName) {
			this.stateMobile = false
			this.mobileInputDisabled = false
		}
		this.emailName = getLocalStorage ('loginerEmail', '')
		if (!this.emailName || this.emailName === 'null') {
			this.stateEmail = false
			this.emailInputDisabled = false
		}
	}
	private validatePhone (value: any, resolve: any) {
		if (!value) {
			(this as any).$fxMessage.error('手机号码不能为空')
			return false
		} else if (!(this as any).$fxUtils.regPhone().test(value)) {
			(this as any).$fxMessage.error('手机号码格式不正确')
			return false
		} else {
			resolve()
		}
	}
	private validateEmail (value: any, resolve: any) {
		if (!value) {
			(this as any).$fxMessage.error('邮箱地址不能为空')
			return false
		} else if (!(this as any).$fxUtils.regEmail().test(value)) {
			(this as any).$fxMessage.error('邮箱地址格式不正确')
			return false
		} else {
			resolve()
		}
	}
	private onUnbindMobile (name: any, code: any) {
		(this as any).$confirm('解绑手机后将无法用手机号码登录，是否继续？', '提示', {
			confirmButtonText: '是',
			cancelButtonText: '否',
			type: 'warning'
		}).then(() => {
			this.onUnbindMobileHandle(name, code)
		})
	}
	private onUnbindEmail (name: any, code: any) {
		(this as any).$confirm('此操作将解绑邮箱，是否继续？', '提示', {
			confirmButtonText: '是',
			cancelButtonText: '否',
			type: 'warning'
		}).then(() => {
			this.onUnbindEmailHandle(name, code)
		})
	}
	private async onUnbindMobileHandle (name: any, code: any) {
		const that = (this as any)
		const params = {
			vCode: code,
			mobile: name
		}
		await (this as any).$fxHttp.requestPost({
			url: '/business/unbindUserTelephone',
			data: params
		}).then((res: any) => {
			that.$fxMessage.success('解绑手机成功')
			this.mobileName = ''
			setLocalStorage('loginerTel', '')
			that.$refs.mobileDetails.initMobile()
			that.$refs.mobileDetails.destoryCode('mobile', '', this.stateMobile)
			this.stateMobile = false
			this.mobileInputDisabled = false
		})
	}
	private async onUnbindEmailHandle (name: any, code: any) {
		const that = (this as any)
		const params = {
			vCode: code,
			email: name
		}
		await (this as any).$fxHttp.requestPost({
			url: '/business/unbindUserMail',
			data: params
		}).then((res: any) => {
			that.$fxMessage.success('解绑邮箱成功')
			this.emailName = ''
			setLocalStorage('loginerEmail', '')
			that.$refs.emailDetails.initMobile()
			that.$refs.emailDetails.destoryCode('email', '', this.stateEmail)
			this.stateEmail = false
			this.emailInputDisabled = false
		})
	}
	private async onBindMobile (name: any, code: any) {
		const that = (this as any)
		if (!name) {
			that.$fxMessage.error('手机号码不能为空')
			return false
		} else if (!that.$fxUtils.regPhone().test(name)) {
			that.$fxMessage.error('手机号码格式不正确')
			return false
		}
		const params = {
			vCode: code,
			telephone: name
		}
		await	(this as any).$fxHttp.requestPost({
			url: '/business/bindingUserTelephone',
			data: params
		}).then((res: any) => {
			that.$fxMessage.success('绑定手机成功')
			this.mobileName = name
			setLocalStorage('loginerTel', name)
			that.$refs.mobileDetails.initMobile()
			that.$refs.mobileDetails.destoryCode('mobile', name, this.stateMobile)
			this.stateMobile = true
			this.mobileInputDisabled = true
		})
	}
	private async onBindEmail (name: any, code: any) {
		const that = (this as any)
		if (!name) {
			that.$fxMessage.error('邮箱地址不能为空')
			return false
		} else if (!that.$fxUtils.regEmail().test(name)) {
			that.$fxMessage.error('邮箱地址格式不正确')
			return false
		}
		const params = {
			vCode: code,
			email: name
		}
		await	(this as any).$fxHttp.requestPost({
			url: '/business/bindingUserMail',
			data: params
		}).then((res: any) => {
			that.$fxMessage.success('绑定邮箱成功')
			this.emailName = name
			setLocalStorage('loginerEmail', name)
			that.$refs.emailDetails.initMobile()
			that.$refs.emailDetails.destoryCode('email', name, this.stateEmail)
			this.stateEmail = true
			this.emailInputDisabled = true
		})
	}
}
